// src/components/application/IdentitySummary.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import { ApplicationIdentityDetails } from "../../types";

export const IdentitySummary: React.FC<ApplicationIdentityDetails> = ({
  firstName,
  lastName,
}) => {
  const { t } = useTranslation();
  return (
    <p>
      <strong>{t("identitySummary.nameLabel")}:</strong> {firstName} {lastName}
    </p>
  );
};
